import './App.css';
import ButtonWrapper from './demo/ButtonWrapper';
import FormWrapper from './demo/FormWrapper';
import IconWrapper from './demo/IconWrapper';
import MenuWrapper from './demo/menuWrapper';
import CardWrapper from './demo/CardWrapper';

function App() {
  return (
    <div className="App">
      <p className="deploy-time">
        <b>배포시점:</b> 06월 20일(화) 오후 5:20
      </p>
      <CardWrapper />
      <IconWrapper />
      <FormWrapper />
      <MenuWrapper />
      <ButtonWrapper />
    </div>
  );
}

export default App;
